export const AUTHENTICATION_GUARDS = {
    AUTHENTICATION_ONE_ID_GUARD: "AUTHENTICATION_ONE_ID_GUARD",
    ONE_ID_INITIALIZATION_GUARD: "ONE_ID_INITIALIZATION_GUARD"
};
